import React from 'react';
import { AlertCircle, Wallet } from 'lucide-react';

export default function PaywallPopup({ isOpen, onClose, onTopUp }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#1B263B]/60 dark:bg-black/80 backdrop-blur-xl animate-fade-in">
      <div className="bg-white dark:bg-slate-900 border border-gray-100 dark:border-slate-800 p-8 rounded-3xl max-w-md w-full shadow-2xl transform transition-all scale-100 animate-slide-up relative overflow-hidden">
        {/* Glow effect */}
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#C47A2C]/10 blur-[40px] rounded-full pointer-events-none"></div>
        <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-[#6B8F71]/10 blur-[40px] rounded-full pointer-events-none"></div>

        <div className="flex flex-col items-center text-center relative z-10">
          <div className="w-20 h-20 bg-[#C47A2C]/10 dark:bg-[#C47A2C]/20 rounded-full flex items-center justify-center mb-6 shadow-inner">
            <AlertCircle size={40} className="text-[#C47A2C]" />
          </div>

          <h2 className="text-2xl font-black text-[#1B263B] dark:text-white mb-3 tracking-tight">Insufficient AI Credits</h2>

          <p className="text-gray-500 dark:text-gray-400 mb-8 leading-relaxed font-medium">
            You've run out of credits to use this advanced AI feature.
            Please top up your account to continue receiving intelligent farming insights.
          </p>

          <div className="flex flex-col w-full gap-3">
            <button
              onClick={onTopUp}
              className="flex items-center justify-center gap-2 w-full py-4 bg-[#C47A2C] hover:bg-[#A36322] text-white rounded-xl font-bold transition-transform hover:-translate-y-0.5 active:scale-95 shadow-[0_4px_15px_rgba(196,122,44,0.3)]"
            >
              <Wallet size={20} />
              Top Up Now
            </button>
            <button
              onClick={onClose}
              className="w-full py-3 bg-transparent text-gray-400 dark:text-gray-500 hover:text-[#1B263B] dark:hover:text-white rounded-xl font-bold transition-colors hover:bg-gray-50 dark:hover:bg-slate-800"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
